import React from "react";
import {
  Autocomplete,
  TextField,
  FormControl,
  Box,
  FormHelperText,
} from "@mui/material";
import { frenchCountries, getFlagUrl } from "./helper";

interface CountryOption {
  label: string;
  code: string;
}

interface CountryAutocompleteProps {
  value: string;
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    newValue: any | null
  ) => void;
  error: boolean;
  helperText: string;
}

const CountryAutocomplete: React.FC<CountryAutocompleteProps> = ({
  value,
  onChange,
  error,
  helperText,
}) => {
  return (
    <FormControl fullWidth error={error}>
      <Autocomplete
        options={frenchCountries as CountryOption[]}
        getOptionLabel={({ label }) => label}
        value={
          frenchCountries.find((country) => country.label === value) || null
        }
        onChange={onChange}
        renderInput={(params) => (
          <TextField {...params} label="Pays *" error={error} />
        )}
        renderOption={(props, option) => {
          const { key, ...restProps } = props;
          const optionTyped = option as CountryOption;
          return (
            <Box
              component="li"
              key={key}
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...restProps}
            >
              <img
                loading="lazy"
                width="20"
                srcSet={`${getFlagUrl(optionTyped.code, "40")} 2x`}
                src={getFlagUrl(optionTyped.code)}
                alt=""
              />
              <p>{option.label}</p>
            </Box>
          );
        }}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CountryAutocomplete;
